import { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { showProgress } from '../../../redux/actions/DealershipActions';
import { ErrorToast } from '../../utils/Utils';
import { transformData } from '../utils';

const useFilterOptions = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({});
  const [filterObjectInitial, setFilterObjectInitial] = useState({});

  const fetchFilterOptions = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const response = await service.get(apiEndpoints.DEALER_FILTER);
      const { filterData, filterObject } = transformData(response);
      setFilters(filterData || {});
      setFilterObjectInitial(filterObject || {});
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  }, [dispatch]);

  useEffect(() => {
    fetchFilterOptions();
  }, [fetchFilterOptions]);

  return { filters, filterObjectInitial };
};

export default useFilterOptions;
